// import * as React from 'react';
// import * as ReactDOM from 'react-dom';
// import {Dropdown, DropdownProps} from './Dropdown';
// import "./Dropdown.scss";
import { JourneyInterface, QuestInterface, Slug } from "@swivl-mono/types";
import { Dropdown, SelectableOption, Spinner } from "@swivl-mono/ui";
import { useEffect, useMemo } from "react";

import LocationsModel from "../../../Models/Locations/Locations.Model";
import VarsModel from "../../../Models/Variables/VarsModel.Model";

interface Props {
  type: LocationsAndGroupsDropdownType;
  groupId?: number;
  locationId?: number;
  name?: string;
  deselectLabel?: string;
  onSelect(groupId?: number, locationId?: number): void;
}
export enum LocationsAndGroupsDropdownType {
  LOCATIONS = "Locations",
  GROUPS = "Groups",
  LOCATIONS_AND_GROUPS = "Locations and Groups",
}
export default function LocationsAndGroupsDropdown(props: Props) {
  const { type, groupId, locationId, onSelect, deselectLabel } = props;
  let { groups } = LocationsModel.useState((s) => s);

  const options = useMemo(() => {
    let options: SelectableOption[] = [];

    if (!groups) {
      return null;
    }
    if (deselectLabel) {
      options.push({ value: "", label: deselectLabel });
    }
    if (type === LocationsAndGroupsDropdownType.LOCATIONS) {
      groups.forEach((group) => {
        options.push({ isHeading: true, label: group.name });
        group.locations.forEach((location) => {
          options.push({ value: String(location.id), label: location.name });
        });
      });
    }
    if (type === LocationsAndGroupsDropdownType.GROUPS) {
      options = [
        ...options,
        ...groups.map((group) => {
          return { value: String(group.id), label: group.name };
        }),
      ];
    }

    if (type === LocationsAndGroupsDropdownType.LOCATIONS_AND_GROUPS) {
      groups.forEach((group) => {
        options.push({ value: String(group.id), label: group.name });
        group.locations.forEach((location) => {
          options.push({ value: String(location.id), label: location.name, indent: 1 });
        });
      });
    }
    return options;
  }, [groups]);

  if (!groups) {
    return <Spinner />;
  }
  let value = "";
  if (type === LocationsAndGroupsDropdownType.GROUPS) {
    value = groupId ? groupId.toString() : "";
  }
  if (type === LocationsAndGroupsDropdownType.LOCATIONS) {
    value = locationId ? locationId.toString() : "";
  }
  if (type === LocationsAndGroupsDropdownType.LOCATIONS_AND_GROUPS) {
    value += groupId ? groupId.toString() : "";
    value += "_";
    value += locationId ? locationId.toString() : "";
  }
  const optionSelected = (option: SelectableOption, _) => {
    let groupId: number | undefined;
    let locationId: number | undefined;
    if (type === LocationsAndGroupsDropdownType.GROUPS) {
      groupId = parseInt(option.value);
    }
    if (type === LocationsAndGroupsDropdownType.LOCATIONS) {
      locationId = parseInt(option.value);
    }
    if (type === LocationsAndGroupsDropdownType.LOCATIONS_AND_GROUPS) {
      const parts = option.value.split("_");
      groupId = parseInt(parts[0]);
      locationId = parseInt(parts[1]);
    }
    onSelect(groupId, locationId);
  };

  return <Dropdown options={options!} value={value} name={props.name} optionSelected={optionSelected} showSearch={true} />;
}
